module.exports = __webpack_public_path__ + "416d6b5d226da44329caa58287a7ebbb.png";